import { render, staticRenderFns } from "./vPopover.vue?vue&type=template&id=c30795d0&scoped=true"
import script from "./vPopover.vue?vue&type=script&lang=ts"
export * from "./vPopover.vue?vue&type=script&lang=ts"
import style0 from "./vPopover.vue?vue&type=style&index=0&id=c30795d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30795d0",
  null
  
)

export default component.exports